<form [formGroup]="form()">
  <label>Formations réglementaires</label>
  <hlm-select #select multiple formControlName="nomFormationReglementaires">
    <hlm-select-trigger>
      <hlm-select-value />
    </hlm-select-trigger>
    <hlm-select-content>
      @for (formation of items | trierPar: 'nom'; track $index) {
        <hlm-option [value]="formation.nom">
          {{ formation.nom }}
        </hlm-option>
      }
    </hlm-select-content>
  </hlm-select>
</form>
